import { createContext } from 'react'

/**
 * Deferred callbacks for the liveness security layer — the analogue of
 * `OtpContext` for the challenge flow.
 *
 * A call site that initiates a liveness-gated action registers what to do once
 * the check resolves (e.g. show the withdrawal result pane), and the global
 * `LivenessCheckModal` invokes it with the terminal `/status` response when the
 * check reaches `PASSED` (`livenessOnSuccess`) or `FAILED` / `TIMED_OUT`
 * (`livenessOnError`).
 *
 * Note the `() => fn` setter idiom at call sites: storing a function in
 * `useState` requires wrapping it, otherwise React treats it as a state updater.
 */
export type LivenessCallback = (response: unknown) => void

export interface LivenessContextValue {
  livenessOnSuccess: LivenessCallback | null
  setLivenessOnSuccess: (cb: LivenessCallback | null) => void
  livenessOnError: LivenessCallback | null
  setLivenessOnError: (cb: LivenessCallback | null) => void
}

export const LivenessContext = createContext<LivenessContextValue>({
  livenessOnSuccess: null,
  setLivenessOnSuccess: () => {},
  livenessOnError: null,
  setLivenessOnError: () => {}
})
